export const TOUR_DATE = 'Tour Date:';
export const ARRIVAL_TIME = 'Arrival time:';
export const TOUR_DURATION = 'Tour duration:';
export const TOUR_ENDS = 'Tour ends:';
export const TOUR_DURATION_MIN = '30 minutes';
export const TOUR_DETAILS = 'Tour Details';
export const MAKE_OFFER_BTN = 'Make offer';
export const REASON = 'Reason: ';
export const QUESTION = 'Would you like to rent ';
